var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.classification !== null
    ? _c(
        "ui-badge",
        { class: _vm.badgeClasses, attrs: { variant: _vm.badgeVariant } },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _vm.icon ? _c(_vm.icon, { tag: "component" }) : _vm._e(),
              _vm._v(" "),
              _c("div", { class: { "ml-2": _vm.icon } }, [
                _vm._v("\n            " + _vm._s(_vm.text) + "\n        "),
              ]),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }